/* CloneAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateComponent = require("../create/CreateComponent");
const _ = require("lodash");

// const NON_CLONEABLE = [
//     "name", // as this is provided as a param to method
//     "shared",
//     "private",
//     "defaultForDm",
//     "defaultForCda",
//     "defaultForOsm"
// ];

// const CLONE_PROPS = [
// "columns",
// "description",
// "rowOrientedProp"
// ];

class CloneAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        ExplorerTemplate,
        userSession,
        activeView,
        Explorables,
        CustomFields
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._templateEntity = ExplorerTemplate;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._userSession = userSession;
        this._CustomFieldsEntity = CustomFields;
        this._firstRun = true;
        this._explorablesEntity = Explorables;
        Explorables.loadExplorables(_.get(this._userSession, "activeOrganization.id")).then(
            (data) => {
                this._explorables = data;
            }
        );

        this._explorerTemplate = new ExplorerTemplate(userSession.activeOrganization.id);
        this.run = this.run.bind(this);
        this.cloneErrorHandler = this.cloneErrorHandler.bind(this);
    }
    run() {
        if (this._activeView) {
            if (this._activeView.pagingFeed) {
                this._selectedPlanId = this._activeView.selectedRows[0];
                return this._templateEntity
                    .loadExplorerTemplate(
                        this._userSession.activeOrganization.id,
                        this._selectedPlanId
                    )
                    .then((template) => {
                        this._template = template;
                        if (this._explorables) {
                            return Promise.resolve();
                        } else {
                            return this._explorablesEntity
                                .loadExplorables(this._userSession.activeOrganization.id)
                                .then((data) => {
                                    this._explorables = data;
                                    return Promise.resolve();
                                });
                        }
                    })
                    .then(() => {
                        return this._cloneTemplate(this._template.name.trim() + "-1");
                    })
                    .catch(this.cloneErrorHandler);
            }
        }
    }

    cloneErrorHandler(error) {
        const {userRejected, errorCode} = error;
        if (userRejected) {
            return;
        }
        this._logger.warn({error}, "Clone action error.");
        switch (errorCode) {
            case "EntityAlreadyExists":
                if (this._firstRun) {
                    this._firstRun = false;
                    return this.requestPlanName(false);
                }
                return this.requestPlanName(true);
            default:
                return this.showCloneError(error);
        }
    }

    showCloneError(error) {
        return this._modalUserFeedback.displayError({error}).catch((error) => {
            if (error.userRejected) {
                return;
            }
            this._logger.warn({error}, "Clone action error.");
        });
    }

    _cloneTemplate(planName) {
        let newItemId;
        this._explorerTemplate.name = planName;
        return this._explorerTemplate
            .create()
            .then(() => {
                const _columns = _.cloneDeep(this._template.columns); //this._cleanColumns();
                const _availableRowOrientationGroups = Object.values(
                    Object.assign({}, this._explorables.getRowOrientedProps())
                );
                if (_availableRowOrientationGroups.length > 0 && this._template.rowOrientedProp) {
                    if (
                        _availableRowOrientationGroups.indexOf(this._template.rowOrientedProp) >= 0
                    ) {
                        this._explorerTemplate.rowOrientedProp = this._template.rowOrientedProp;
                    }
                } else {
                    this._explorerTemplate.rowOrientedProp = null;
                }
                return this._CustomFieldsEntity
                    .loadCustomFields(_.get(this._userSession, "activeOrganization.id"))
                    .then((cfentity) => {
                        const fields = cfentity.fields;
                        const cfids = Object.keys(fields);
                        const cfields = Object.entries(fields);

                        _columns.forEach((col, idx) => {
                            if (col.path[0] === "customFieldValues") {
                                if (cfids.indexOf(col.path[1]) < 0) {
                                    for (let i = 0; i < cfields.length; i++) {
                                        if (
                                            col.flattenedPath.split(">")[1] ===
                                                cfields[i][1].name &&
                                            col.dataType.toLowerCase() ===
                                                cfields[i][1].dataType.toLowerCase()
                                        ) {
                                            // console.log(col, cfields[i]);
                                            col.path[1] = cfields[i][0];
                                            _columns[idx].path[1] = cfields[i][0];
                                            break;
                                        }
                                    }
                                }
                            }
                        });
                        this._explorerTemplate.columns = _columns;
                        this._explorerTemplate.description = this._template.description || "";
                        return this._explorerTemplate.update();
                    });
            })
            .then((result) => {
                newItemId = result.id;
                return this._modalUserFeedback.hideDisplayed().then(() => {
                    return this.launchEditor(newItemId, result.properties.name);
                });
            })
            .then(() => {
                if (typeof this._activeView.resetSelection === "function") {
                    // fix for 22682 - making a small delay, to be sure the grid is updated with new item
                    _.delay(() => this._activeView.resetSelection([newItemId]), 200);
                }
            });
    }

    _cleanColumns() {
        function findAllByKey(obj, keyToFind) {
            return Object.entries(obj).reduce((acc, [key, value]) => {
                if (key === keyToFind) {
                    acc.push(Array.isArray(value) ? value.join("") : value);
                } else if (typeof value === "object" && value && !Array.isArray(value)) {
                    return acc.concat(findAllByKey(value, keyToFind));
                }
                return acc;
            }, []);
        }
        const explorables = this._explorables.getExplorables();
        const paths = findAllByKey(explorables, "path");
        const templateColumns = this._template.columns.filter((col) => {
            if (paths.indexOf(col.path.join("")) >= 0) {
                return true;
            }
            return false;
        });
        return templateColumns;
    }

    requestPlanName(isNotUniq) {
        return this._modalUserFeedback
            .displayCustom(
                new CreateComponent(
                    this._logger,
                    "Clone Template",
                    isNotUniq
                        ? "The entered name is not unique. Please specify a unique name for this cloned template."
                        : "Please specify a unique name for this cloned template.",
                    "Enter Template Name"
                ),
                {dontHide: true}
            )
            .then((result) => {
                return this._modalUserFeedback.displayLoading().then(() => {
                    return this._cloneTemplate(result.trim());
                });
            })
            .catch((err) => {
                if (err && err.userRejected) {
                    this._logger.warn({error: err}, "CaptureAction.run() - User Canceled");
                    return this._modalUserFeedback.hideDisplayed();
                } else {
                    return this.cloneErrorHandler(err);
                }
            });
    }
    launchEditor(id, name, expandOpt) {
        if (!id) {
            throw "Template creation error, invalid template id.";
        }
        let editorState = {
            fqn: Registrations.DEIE_VIEW_DETAILS,
            viewState: {createMode: true},
        };
        let launchOpts = {id: id, title: name, expandOpt};
        return this._gameEditor.launchDataExplorerEditor(editorState, launchOpts);
    }
}

module.exports = CloneAction;

CloneAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.ExplorerTemplate",
    "$teve.userSession",
    "gameEditor.activeView",
    "$teve.entities.Explorables",
    "$teve.entities.CustomFields",
];

CloneAction.$displayDetails = {
    type: "Action",
    name: "CloneAction",
    icon: "common.duplicate",
    title: "Clone template",
    shown: true,
    order: 2,
};
